const { host } = window.location;

const srcSetDefinition = [
  { type: "1x", w: 140 },
  { type: "2x", w: 280 },
  { type: "3x", w: 420 },
];

export const CONTENT_TYPES = {
  moduleText: "moduleText",
  moduleMenu: "moduleMenu",
};

export function responsiveImage(src) {
  return srcSetDefinition.map(({ type, w }) => `${src}?w=${w} ${type}`).join(", ");
}

export function replaceHost(link) {
  try {
    const url = new URL(link);
    url.host = host;
    url.protocol = window.location.protocol;
    return url.href;
  } catch {
    return link;
  }
}
